import { createContext } from 'react';
import type { ConstructorValue } from '../../features/design-constructor';
import type { Template, ThemeSource } from './types';

export interface ThemeContextValue {
  value: ConstructorValue;
  template: Template;
  source: ThemeSource;
  setValue: (next: ConstructorValue, template?: Template) => void;
  reset: () => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
